import React, { useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useEffect } from 'react';
import { getTmList } from 'API/Mapping/api';


const columns = [
    { field: '_id', headerName: 'TM ID', width: 90 },
    {
        field: 'username',
        headerName: 'TM NAME',
        width: 150,
        editable: true,
    },
    {
        field: 'mobile',
        headerName: 'MOBILE NUMBER',
        width: 150,
        editable: true,
    },
    {
        field: 'emailid',
        headerName: 'EMAIL',
        width: 200,
        editable: true,
    },
    {
        field: 'district',
        headerName: 'LOCATION',
        description: 'This column has a value getter and is not sortable.',
        sortable: false,
        width: 160,
        // valueGetter: (value, row) => `${row.firstName || ''} ${row.lastName || ''}`,
    },
];

// const rows = [
//     { id: 121, mobile: '1234567890', name: 'Jon', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 122, mobile: '1234567890', name: 'Cersei', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 123, mobile: '1234567890', name: 'Jaime', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 124, mobile: '1234567890', name: 'Arya', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 125, mobile: '1234567890', name: 'Daenerys', mail: null, location: 'asd' },
//     { id: 126, mobile: '1234567890', name: null, mail: 'demo@gmail.com', location: 'asd' },
//     { id: 127, mobile: '1234567890', name: 'Ferrara', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 128, mobile: '1234567890', name: 'Rossini', mail: 'demo@gmail.com', location: 'asd' },
//     { id: 129, mobile: '1234567890', name: 'Harvey', mail: 'demo@gmail.com', location: 'asd' },
// ];

export default function TmTable(props) {

    const [SelectedRows, setSelectedRows] = useState(null)
    const[rows,setRow]=useState(null)

    const handleRowSelection = (selectedRowIds) => {
        console.log(selectedRowIds);
        console.log(rows);
        console.log(selectedRowIds);
        const selectedRowsData = selectedRowIds.map((id) =>
            rows.find((row) => row._id === id)
        );
        console.log(selectedRowsData);
        setSelectedRows(selectedRowsData[0]);
        props.handleChange(selectedRowsData[0])
    };
    console.log(SelectedRows);

    useEffect(()=>{
        getTmList("ALL","ALL",setRow)
    },[])
    return (
        <Box sx={{ height: 400, width: '100%' }}>
            {
                SelectedRows ?
                    <TableContainer component={Paper}>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table" size='small'>
                            <TableHead>
                                <TableRow>
                                    <TableCell>TM ID</TableCell>
                                    <TableCell align="right">NAME</TableCell>
                                    <TableCell align="right">MOBILE NUMBER</TableCell>
                                    <TableCell align="right">EMAIL</TableCell>
                                    <TableCell align="right">LOCATION</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                <TableRow
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                >
                                    <TableCell component="th" scope="row">
                                        {SelectedRows._id}
                                    </TableCell>
                                    <TableCell align="right">{SelectedRows.name}</TableCell>
                                    <TableCell align="right">{SelectedRows.mobile}</TableCell>
                                    <TableCell align="right">{SelectedRows.email}</TableCell>
                                    <TableCell align="right">{SelectedRows.district}</TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                    :
                    <DataGrid
                        rows={rows?rows:[]}
                        columns={columns}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 5,
                                },
                            },
                        }}
                        pageSizeOptions={[5]}
                        checkboxSelection
                        getRowId={(row)=>row._id}
                        disableRowSelectionOnClick
                        onRowSelectionModelChange={(e) => handleRowSelection(e)}
                    />
            }

        </Box>
    );
}